import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Arbor } from "../models/Arbor";

export const getArbors = async (
	params: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.partId) parameters.push({ name: "PartId", value: params.partId });

	const resp = await apiService.callV2("[M2].[GetArbors]", parameters, signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Arbor[];
	} else {
		throw new Error(resp.message || "Error fetching arbors");
	}
};
export const upsertArbor = async (arbor: Arbor) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "PartId", value: arbor.PartId },
		{ name: "PartName", value: arbor.PartName },
		{ name: "LocationId", value: arbor.LocationId },
		{ name: "Comments", value: arbor.Comments },
	];

	const resp = await apiService.callV2("[M2].[UpsertArbor]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting arbor");
	}
};

export const deleteArbor = async (partIds: string | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartIds", value: partIds }];

	const resp = await apiService.callV2("[M2].[DeleteArbor]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting arbor");
	}
};
